<template>
  <div style="display: contents">
    <v-dialog
      v-for="modal in confirmModals"
      :key="modal.id"
      :value="modal.value"
      :retain-focus="false"
      max-width="500px"
      @input="!$event && modal.cancel()"
    >
      <v-card class="confirm-modal">
        <v-card-text class="pt-6 pb-2 text-center">
          <v-icon
            size="56"
            color="warning"
            class="mb-4"
          >
            mdi-alert-circle-outline
          </v-icon>

          <div class="text-h6 mb-2 font-weight-medium">
            {{ modal.text }}
          </div>

          <div v-if="modal.message" class="text-body-2 grey--text text--darken-1 mt-2">
            {{ modal.message }}
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-4 justify-end">
          <v-btn
            text
            color="error"
            @click="modal.cancel"
          >
            {{ modal.cancelLabel ?? $t('ui.cancel') }}
          </v-btn>

          <v-btn
            color="primary"
            @click="modal.confirm"
          >
            {{ modal.confirmLabel ?? $t('ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">

// libs.
import { typedMapGetters } from '@/store/modules/utils';

export default {
  name: 'ConfirmModal',
  computed: {
    ...typedMapGetters({
      confirmModals: 'confirmModals',
    }),
  },
};
</script>

<style lang="scss" scoped>
.confirm-modal {
  border-radius: 12px !important;

  .v-card__text {
    color: #2c3e50;
  }

  .v-btn {
    text-transform: none;
    font-weight: 500;
    letter-spacing: 0.25px;
  }
}
</style>
